import { SxProps, Theme } from '@mui/material';

export const widgetContainerStyles: SxProps<Theme> = {
	backgroundColor: 'white',
	borderRadius: '1rem',
	padding: { xs: '2rem 1.5rem', md: '3rem 2.5rem' },
	width: '100%',
	maxWidth: { xs: '100%', sm: '100%', md: '600px', lg: '700px' },
};

export const locationCardStyles: SxProps<Theme> = {
	backgroundColor: 'white',
	border: '1px solid',
	borderColor: 'grey.A400',
	borderRadius: { xs: 2, md: 1 },
	py: { xs: '11px', md: '12px' },
	px: '16px',
	width: '100%',
	marginBottom: { xs: 3.5, md: 3 },
	marginTop: { xs: 2, md: 3 },
};

export const locationHeaderStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	marginBottom: '0.75rem',
};

export const locationInfoStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', sm: 'row' },
	justifyContent: 'space-between',
	alignItems: { xs: 'flex-start', sm: 'flex-end' },
};

export const locationNameStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	color: '#0A2F54',
};

export const locationAddressStyles: SxProps<Theme> = {
	color: 'text.interactive',
	fontSize: '14px',
	textDecoration: 'underline',
	display: 'block',
};

export const locationPhoneStyles: SxProps<Theme> = {
	color: 'text.interactive',
	display: 'block',
	marginTop: { xs: 0.25, md: 0.5 },
	fontSize: '14px',
	textDecoration: 'underline',
};

export const locationDistanceStyles: SxProps<Theme> = {
	color: 'text.secondary',
};

export const changeLocationButtonStyles: SxProps<Theme> = {
	border: '1px solid',
	minWidth: '180px',
	marginTop: { xs: '5px', md: 2 },
};

export const zipCodeInputContainerStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', sm: 'row' },
	flexWrap: 'wrap',
	alignItems: { xs: 'flex-start', sm: 'center' },
	gap: { xs: '16px', sm: '40px' },
	marginBottom: '2rem',
};

export const headingStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	fontSize: { xs: '1.75rem', md: '2rem' },
	fontWeight: 500,
	color: '#0A2F54',
	marginBottom: '1.5rem',
	lineHeight: 1.3,
};

export const zipCodeHeadingStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	fontSize: { xs: '1.125rem', sm: '1.25rem' },
	fontWeight: 400,
	color: '#0A2F54',
	marginBottom: '0.25rem',
	textAlign: 'left',
	lineHeight: 1.3,
};

export const subHeadingStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	fontSize: { xs: '1.125rem', md: '1.25rem' },
	fontWeight: 600,
	color: '#0A2F54',
	marginBottom: '0.5rem',
	lineHeight: 1.3,
};

export const zipCodeHelperTextStyles: SxProps<Theme> = {
	textAlign: 'left',
};

export const helperTextStyles: SxProps<Theme> = {
	fontSize: '1rem',
	color: '#5C6F82',
	marginBottom: '1.5rem',
	lineHeight: 1.5,
};

export const dividerStyles: SxProps<Theme> = {
	marginY: '2rem',
	borderColor: '#D1D9E2',
	opacity: 1,
};

export const zipCodeFormContainerStyles: SxProps<Theme> = {
	width: { xs: '100%', sm: 'auto' },
};

export const zipCodeInputFieldStyles: SxProps<Theme> = {
	width: { xs: '100%', sm: '220px' },
	'& .MuiOutlinedInput-root': {
		backgroundColor: 'white',
	},
};

export const searchButtonStyles: SxProps<Theme> = {
	minWidth: { xs: '100%', sm: '120px' },
	padding: '0.875rem 2rem',
	fontWeight: 500,
	textTransform: 'none',
	fontSize: '1rem',
	borderRadius: '2rem',
	backgroundColor: '#E89B4C',
	color: '#0A2F54',
	fontFamily: 'Beausite Classic',
	boxShadow: 'none',
	'&:hover': {
		backgroundColor: '#D88A3B',
		boxShadow: 'none',
	},
	'&:active': {
		boxShadow: 'none',
	},
	'&:disabled': {
		opacity: 0.5,
	},
};

export const continueButtonStyles: SxProps<Theme> = {
	width: '100%',
	padding: '0.875rem 2rem',
	fontWeight: 400,
	textTransform: 'none',
	fontSize: '1rem',
	borderRadius: '2rem',
	borderColor: '#1A2B49',
	color: '#1A2B49',
	borderWidth: '1px',
	'&:hover': {
		borderWidth: '1px',
		borderColor: '#1A2B49',
		backgroundColor: 'rgba(26, 43, 73, 0.04)',
	},
};

export const appointmentsScrollContainerStyles: SxProps<Theme> = {
	overflowX: 'auto',
	marginBottom: '1.5rem',
	'&::-webkit-scrollbar': {
		height: '8px',
	},
	'&::-webkit-scrollbar-track': {
		backgroundColor: 'background.default',
		borderRadius: '4px',
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: 'primary.main',
		borderRadius: '4px',
	},
};

export const appointmentsDayGroupStyles: SxProps<Theme> = {
	display: 'flex',
	gap: '1rem',
	paddingBottom: '0.5rem',
};

export const dayRowStyles: SxProps<Theme> = {
	marginBottom: '2rem',
};

const chevronLeft = encodeURIComponent(`
	<svg xmlns="http://www.w3.org/2000/svg" fill="#0a2f54" viewBox="0 0 24 24">
		<path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z"/>
	</svg>
`);

const chevronRight = encodeURIComponent(`
	<svg xmlns="http://www.w3.org/2000/svg" fill="#0a2f54" viewBox="0 0 24 24">
		<path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>
	</svg>
`);

export const swiperContainerStyles: SxProps<Theme> = {
	width: '100%',
	position: 'relative',
	overflow: 'visible',
	'& [class*="swiper-button-"]': {
		'&::after': {
			content: 'none',
		},
		display: { xs: 'none', md: 'flex' },
		alignItems: 'center',
		justifyContent: 'center',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: '40px 40px',
		position: 'absolute',
		width: '40px',
		height: '40px',
		zIndex: 10,
		cursor: 'pointer',
		'&.swiper-button-disabled': {
			opacity: 0.3,
			pointerEvents: 'none',
		},
	},
	'& [class*="swiper-button-prev"]': {
		backgroundImage: `url('data:image/svg+xml,${chevronLeft}')`,
		left: '-32px',
		top: '50%',
		transform: 'translateY(-50%)',
	},
	'& [class*="swiper-button-next"]': {
		backgroundImage: `url('data:image/svg+xml,${chevronRight}')`,
		right: '-32px',
		top: '50%',
		transform: 'translateY(-50%)',
	},
	'& .swiper': {
		overflow: 'hidden',
		'& .swiper-scrollbar': {
			height: '4px',
			backgroundColor: '#F5F7FA',
			borderRadius: '2px',
			bottom: '-12px',
			'& .swiper-scrollbar-drag': {
				backgroundColor: '#075E86',
				borderRadius: '2px',
			},
		},
	},
	'& .swiper-wrapper': {
		alignItems: 'center',
	},
};

export const timeSlotsRowStyles: SxProps<Theme> = {
	display: 'flex',
	gap: '0.75rem',
	overflowX: 'auto',
	paddingBottom: '0.5rem',
	paddingX: '0.5rem',
	marginX: '32px',
	scrollBehavior: 'smooth',
	'&::-webkit-scrollbar': {
		height: '6px',
	},
	'&::-webkit-scrollbar-track': {
		backgroundColor: '#F5F7FA',
		borderRadius: '3px',
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#D1D9E2',
		borderRadius: '3px',
		'&:hover': {
			backgroundColor: '#B8C4D0',
		},
	},
};

export const dayHeaderStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	fontWeight: 500,
	fontSize: { xs: '1rem', md: '1.0625rem' },
	marginBottom: '0.875rem',
	color: '#0A2F54',
	lineHeight: 1.4,
};

export const timeSlotButtonStyles = (isSelected: boolean): SxProps<Theme> => ({
	fontFamily: 'Beausite Classic',
	padding: 0,
	fontSize: { xs: '0.875rem', md: '1rem' },
	fontWeight: 400,
	borderRadius: '0.5rem',
	border: isSelected ? '2px solid' : '1px solid',
	borderColor: isSelected ? '#075E86' : '#D1D5DB',
	backgroundColor: 'white',
	color: '#075E86',
	cursor: 'pointer',
	transition: 'all 0.15s ease',
	whiteSpace: 'nowrap',
	width: { sm: '105px', xs: '86px' },
	height: { sm: '52px', xs: '46px' },
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'relative',
	'&:hover': {
		borderColor: isSelected ? '#075E86' : '#0052A3',
		backgroundColor: isSelected ? 'white' : '#F9FAFB',
		color: '#075E86',
	},
	'&:disabled': {
		opacity: 0.5,
		cursor: 'not-allowed',
	},
});

export const buttonGroupStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	gap: '1rem',
	marginTop: '2rem',
};

export const moreTimesButtonStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	flex: '1',
	width: { xs: '100%', md: 'auto' },
	padding: '0.875rem 2rem',
	fontWeight: 400,
	textTransform: 'none',
	fontSize: '1rem',
	borderRadius: '2rem',
	borderColor: '#1A2B49',
	color: '#1A2B49',
	borderWidth: '1px',
	'&:hover': {
		borderWidth: '1px',
		borderColor: '#1A2B49',
		backgroundColor: 'rgba(26, 43, 73, 0.04)',
	},
};

export const scheduleButtonStyles = (isDisabled: boolean): SxProps<Theme> => ({
	fontFamily: 'Beausite Classic',
	flex: '1',
	width: { xs: '100%', md: 'auto' },
	padding: '0.875rem 2rem',
	fontWeight: 400,
	textTransform: 'none',
	fontSize: '1rem',
	borderRadius: '2rem',
	color: '#0A2F54',
	backgroundColor: isDisabled ? '#C4C4C4' : '#E89B4C',
	'&:hover': {
		backgroundColor: isDisabled ? '#C4C4C4' : '#D88A3B',
	},
	'&:disabled': {
		backgroundColor: '#C4C4C4',
		opacity: 1,
	},
});

export const loadingContainerStyles: SxProps<Theme> = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	padding: '3rem',
};

export const errorContainerStyles: SxProps<Theme> = {
	padding: '2rem',
	textAlign: 'center',
	color: '#0A2F54',
};

export const noAppointmentsStyles: SxProps<Theme> = {
	padding: '2rem',
	textAlign: 'center',
	color: '#0A2F54',
};

// Drawer styles
export const drawerContentStyles: SxProps<Theme> = {
	padding: { sm: '40px', xs: '30px' },
	position: 'relative',
};

export const drawerHeaderStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	color: '#0A2F54',
	fontWeight: 400,
};

export const drawerSubHeaderStyles: SxProps<Theme> = {
	color: 'text.secondary',
};

export const facilityCardStyles: SxProps<Theme> = {
	borderRadius: 1,
	py: '12px',
	px: '16px',
	maxWidth: '525px',
	border: '1px solid',
	borderColor: 'grey.A400',
	mb: 3,
};

export const facilityNameStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	color: '#0A2F54',
	fontWeight: 600,
	fontSize: '1rem',
};

export const facilityAddressStyles: SxProps<Theme> = {
	color: '#075E86',
	fontSize: '0.875rem',
	mb: 0.5,
};

export const facilityPhoneStyles: SxProps<Theme> = {
	color: '#075E86',
	fontSize: '0.875rem',
	display: 'block',
	mt: 0.5,
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'underline',
	},
};

export const facilityDistanceStyles: SxProps<Theme> = {
	fontSize: '0.875rem',
	color: 'text.tertiary',
};

export const selectCenterButtonStyles: SxProps<Theme> = {
	border: '1px solid',
	width: 'max-content',
};
